import Nav from "../components/Nav/nav";
import PcardView from "../components/PAccount/PcardView";
import Whatsapp from "../Whatsapp/whatsapp";

const ViewPage = () => {
  return (
    <div>
      <Nav />
      <PcardView />
      <Whatsapp />
    </div>
  );
};

export default ViewPage;
